import { getFirestore, connectFirestoreEmulator, Firestore } from '@angular/fire/firestore';
import { inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

export function firestoreFactory(): () => Firestore {
  return () => {
    const platformId = inject(PLATFORM_ID);
    const firestore = getFirestore(); // Initialisiert Firestore
    if ('useEmulators' in environment && environment.useEmulators && isPlatformBrowser(platformId)) {
      try {
        connectFirestoreEmulator(firestore, 'localhost', 8080);
      } catch (e) {
        console.error("An error occured while trying to connect to firestore emulator:", e);
      }
    }
    return firestore;
  }
}